// Material Dark — exact colors from LVGL 7 lv_theme_material.c
import { mix, darken, OPA_30 } from '../themeUtils.js';

const COLOR_SCR          = '#444b5a';
const COLOR_SCR_TEXT     = '#e7e9ec';
const COLOR_BG           = '#586273';
const COLOR_BG_PR        = '#494f57';
const COLOR_BG_SEC       = '#45494d';
const COLOR_BG_SEC_TEXT  = '#a5a8ad';
const COLOR_BG_BORDER    = '#808a97';
const COLOR_BG_BORDER_PR = '#5f656e';
const COLOR_BG_TEXT      = '#ffffff';
const COLOR_BG_TEXT_DIS  = '#999999';
const COLOR_BTN_DIS      = '#888888';
const COLOR_BTN_BORDER_INA = '#404040';

export function buildContext(primary, _secondary) {
    const pretty = {
        bg_color:     COLOR_BG,
        bg_opa:       255,
        border_color: COLOR_BG_BORDER,
        border_width: 2,
        radius:       8,
        text_color:   COLOR_BG_TEXT,
        shadow_width:  0,
        shadow_color: '#000000',
        shadow_ofs_x: 0,
        shadow_ofs_y: 0,
        outline_width: 0,
        outline_color: '#000000',
        outline_pad:   0,
    };

    const btnStyle = {
        bg_color:     COLOR_BG,
        bg_opa:       255,
        border_color: primary,
        border_width: 1,
        text_color:   COLOR_BG_TEXT,
        shadow_width:  0,
        shadow_color: '#000000',
        shadow_ofs_x: 0,
        shadow_ofs_y: 0,
        outline_width: 0,
        outline_color: '#000000',
        outline_pad:   0,

        states: {
            // Matches lv_theme_material.c's styles->btn state overrides exactly (dark branch):
            // CHECKED = theme.color_primary; PRESSED = lv_color_mix(primary, COLOR_BTN, OPA_30)
            // (COLOR_BTN == COLOR_BG in the dark palette); CHECKED|PRESSED =
            // lv_color_darken(primary, OPA_30); DISABLED/DISABLED|CHECKED text_color is a fixed
            // #888888 literal in firmware for both light and dark (NOT the generic
            // COLOR_BG_TEXT_DIS constant, which happens to be a different gray, #999999) — reuse
            // COLOR_BTN_DIS, which is independently already '#888888'.
            checked:          { bg_color: primary,                    text_color: '#ffffff' },
            pressed:          { bg_color: mix(primary, COLOR_BG, OPA_30), text_color: COLOR_BG_TEXT },
            pressedChecked:   { bg_color: darken(primary, OPA_30),    text_color: '#ffffff' },
            disabled:         { text_color: COLOR_BTN_DIS },
            disabledChecked:  { bg_color: COLOR_BTN_DIS,               text_color: COLOR_BTN_DIS },
        },
    };

    return {
        primary,
        pretty,
        btnStyle,
        COLOR_SCR,
        COLOR_SCR_TEXT,
        COLOR_BG,
        COLOR_BG_PR,
        COLOR_BG_SEC,
        COLOR_BG_SEC_TEXT,
        COLOR_BG_BORDER,
        COLOR_BG_BORDER_PR,
        COLOR_BG_TEXT,
        COLOR_BG_TEXT_DIS,
        COLOR_BTN_DIS,
        COLOR_BTN_BORDER_INA,
    };
}
